export default "__VITE_ASSET__BZef4YBg__"